export const abilities = {
    admin: [
        'components.view',
        'components.create',
        'components.update',
        'components.publish',
        'components.deprecate',
        'component-groups.view',
        'component-groups.create',
        'component-ctas.view',
        'component-ctas.create',
        'component-ctas.update',
        'component-ctas.delete',
        'therapy-templates.view',
        'therapy-templates.create',
        'therapy-templates.update',
        'therapy-templates.publish',
        'medicines.view',
        'medicines.create',
        'medicines.update',
        'medicines.deactivate',
        'assignments.view',
        'assignments.create',
        'assignments.delete',
        'reference-lists.view',
        'reference-lists.create',
        'reference-lists.update',
        'audit-events.view',
        'statistics.view',
        'users.view',
    ],
    doctor: [
        'therapies.view',
        'therapies.create-medical',
        'therapies.modify',
        'therapies.approve',
        'therapies.reject',
        'therapies.activate',
        'therapies.pause',
        'therapies.resume',
        'therapies.abort',
        'therapies.close',
        'therapy-drafts.view',
        'therapy-drafts.review',
        'tasks.view',
        'components.view',
        'therapy-templates.view',
        'medicines.view',
    ],
};

export const rolePrecedence = ['admin', 'doctor', 'patient'];

// The patient app: after login we redirect there once.
export const otherAppUrl = process.env.VUE_APP_APP_URL || 'http://localhost:8081';

export const landingPages = {
    admin: '/admin/components',
    doctor: '/doctor/drafts',
};

export function abilitiesFor(roles = []) {
    const set = new Set();

    (roles || []).forEach((role) => {
        (abilities[role] || []).forEach((ability) => set.add(ability));
    });

    return Array.from(set);
}

export default abilities;
